import { ApiResponse, baseAPI, fetcher } from './base-api';
import {
  AcademyEntity,
  AcademyListResponse,
  AcademyRegionEntity,
  GetAcademyListParams,
} from './types/academy.type';
import {
  GetLicenseTestCourseListParams,
  LicenseTestCourseDetailEntity,
  LicenseTestCourseListResponse,
  LicenseTestCourseRegionEntity,
  TestCourseArticleAcademyBoardTypesRow,
  TestCourseArticleAcademyEntity,
} from './types/license-test-course.type';

export const getLicenseTestCourseDetail = async (
  id: number,
): Promise<ApiResponse<LicenseTestCourseDetailEntity>> => {
  return fetcher<LicenseTestCourseDetailEntity>(
    `/academy/license-test-course/detail/${id}`,
  );
};

export const getLicenseTestCourseList = async (
  params?: GetLicenseTestCourseListParams,
): Promise<ApiResponse<LicenseTestCourseListResponse>> => {
  return fetcher<LicenseTestCourseListResponse>(
    '/academy/license-test-course',
    { params },
  );
};

export const getTestCourseArticleAcademyList = async (): Promise<
  ApiResponse<TestCourseArticleAcademyEntity[]>
> => {
  return fetcher<TestCourseArticleAcademyEntity[]>(
    '/academy/license-test-course/test-course-article/academies',
  );
};

/** 본문 code가 200일 때만 성공으로 처리 */
export const getTestCourseArticleAcademyBoardTypes = async (): Promise<
  ApiResponse<TestCourseArticleAcademyBoardTypesRow[]>
> => {
  const res = await baseAPI.get<{
    code: number;
    message: string;
    data: TestCourseArticleAcademyBoardTypesRow[];
  }>('/academy/license-test-course/test-course-article/academy-board-types');

  if (res.data.code !== 200) {
    throw {
      error: 'API_ERROR',
      message: res.data.message || '시험장별 게시판 타입 조회에 실패했습니다.',
    };
  }

  return {
    status: res.status,
    message: res.statusText,
    data: res.data.data,
  };
};

export const getLicenseTestCourseRegionList = async (): Promise<
  ApiResponse<LicenseTestCourseRegionEntity[]>
> => {
  const response = await fetcher<LicenseTestCourseRegionEntity[]>(
    '/academy/license-test-course/region',
  );
  return {
    ...response,
    data: response.data.map(mapSidoToRegion),
  };
};

// 변환 함수
function mapSidoToRegion(
  region: LicenseTestCourseRegionEntity,
): LicenseTestCourseRegionEntity {
  return {
    ...region,
    label: region.name,
    value: String(region.id),
    subRegions: region.subRegions?.map(mapSigunguToRegion),
  };
}
function mapSigunguToRegion(
  region: LicenseTestCourseRegionEntity,
): LicenseTestCourseRegionEntity {
  return {
    ...region,
    label: region.name,
    value: String(region.id),
  };
}

// ── 운전면허학원(/academy) ──────────────────────────────────────────────
// 시험장(license-test-course)과 다른 데이터다(학원 type IN ('academy','exam_academy')).

export const getAcademyDetail = async (
  id: number,
): Promise<ApiResponse<AcademyEntity>> => {
  return fetcher<AcademyEntity>(`/academy/detail/${id}`);
};

export const getAcademyList = async (
  params?: GetAcademyListParams,
): Promise<ApiResponse<AcademyListResponse>> => {
  return fetcher<AcademyListResponse>('/academy', { params });
};

export const getAcademyRegionList = async (): Promise<
  ApiResponse<AcademyRegionEntity[]>
> => {
  const response = await fetcher<AcademyRegionEntity[]>('/academy/region');
  return {
    ...response,
    data: response.data.map(mapAcademySidoToRegion),
  };
};

function mapAcademySidoToRegion(
  region: AcademyRegionEntity,
): AcademyRegionEntity {
  return {
    ...region,
    label: region.name,
    value: String(region.id),
    subRegions: region.subRegions?.map((sub) => ({
      ...sub,
      label: sub.name,
      value: String(sub.id),
    })),
  };
}
